import styled from 'styled-components';

export const SuggestionButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
`;
